// 배너 관련된 FETCH API 함수 파일
import { banners } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

// main banners fetch api
function fetchMainBanners() {
  return  banners.post('list.do', {
    groupCode: "FUSAPP",
    searchBannerType: "maintop",
  }).then((res) => {
    return checkLimitedUser(res)
  })
}

// sub banners fetch api
function fetchSubBanners() {
  return banners.post('list.do', {
    groupCode: 'FUSAPP',
    searchBannerType: 'mainsub'
  }).then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchCommunityBanners() {
  return banners.post('list.do', {
    searchBannerType: 'community',
  }).then((res) => {
    return checkLimitedUser(res)
  })
}

export { fetchMainBanners, fetchSubBanners, fetchCommunityBanners }